<div [ngClass]="shopLocatorFacade.mode$ | async" class="shop-locator-page">
    <div class="shop-list-title-container">
        @if (displayBackButton()) {
            <h-back-button-deprecated class="mobile-only" (goBack)="handleGoBack()" [autoAddMargin]="false">
                <span hSrOnlyNoSnippet i18n="@@node--hermes-product-display-default.back"> Back </span>
            </h-back-button-deprecated>
        }

        <h4 class="regular-uppercase" [ngClass]="shopLocatorFacade.mode$ | async">{{ pageTitle }}</h4>

        <ng-container *ngTemplateOutlet="searchSection"></ng-container>

        @if ((shopLocatorFacade.mode$ | async) === "no-map" || (shopLocatorFacade.mode$ | async) === "map") {
            <ng-container *ngTemplateOutlet="listContent"></ng-container>
        }
        @if ((isNavigationBarDisplayed$ | async) === true) {
            <h-shop-locator-navigation class="mobile-only"></h-shop-locator-navigation>
        }
    </div>

    @if ((shopLocatorFacade.mode$ | async) === "map-mobile") {
        <div>
            <ng-container *ngTemplateOutlet="mapContent"></ng-container>
        </div>
    }

    <div class="left-flex-container">
        @if ((shopLocatorFacade.mode$ | async) === "map" || context.isInServerMode()) {
            <div class="map-desktop">
                <!-- This id 'shop-locator-map' is used to handle HoveredShop -->
                <h-shop-locator-map id="shop-locator-map" (clickedShop)="clickedShop($event)"></h-shop-locator-map>
                @if ((isNavigationBarDisplayed$ | async) === true) {
                    <h-shop-locator-navigation></h-shop-locator-navigation>
                }
            </div>
        }
    </div>

    @if ((isNavigationBarDisplayed$ | async) === true) {
        <h-seo-links [seoLinks]="(seoLinks$ | async) ?? []"></h-seo-links>
    }

    <h-livechat [pageType]="'Store Locator'"></h-livechat>
</div>

<ng-template #mapContent>
    <!-- This id 'shop-locator-map' is used to handle HoveredShop -->
    <h-shop-locator-map (clickedShop)="clickedShop($event)" id="shop-locator-map"></h-shop-locator-map>

    <h-shop-locator-map-item
        [linkMode]="'external'"
        [sectionsToDisplay]="sectionsToDisplay()"
        (shopInfoEvents)="shopInfoEvents($event)"></h-shop-locator-map-item>
</ng-template>

<ng-template #listContent>
    <h-shop-locator-shops-list (shopInfoEvents)="shopInfoEvents($event)"></h-shop-locator-shops-list>
</ng-template>

<ng-template #searchSection>
    <h-shop-locator-search>
        <h-shop-locator-search-location
            [isWorldwideResearch]="true"
            (geolocationButtonSelected)="geolocationButtonSelected($event)">
        </h-shop-locator-search-location>
    </h-shop-locator-search>
</ng-template>
